<template>
  <el-dialog
      id="packageAmountEdit"
      :title="title"
      :visible="show"
      width="600px"
      :close-on-click-modal="false"
      @open="handleDialogOpen"
      @close="handleDialogClose"
  >
    <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="150px"
        v-loading="loading"
    >
      <el-form-item
          prop="qq_pay_pk"
          label="qq_pay_pk"
      >
        <el-input
            v-model="form.qq_pay_pk"
            auto-complete="off"
            :placeholder="$t('message.inputAmount')"
        />
      </el-form-item>
      <el-form-item
          prop="qq_pay_game_pk"
          label="qq_pay_game_pk"
      >
        <el-input
            v-model="form.qq_pay_game_pk"
            auto-complete="off"
            :placeholder="$t('message.inputAmount')"
        />
      </el-form-item>
      <el-form-item
          prop="dummy_pay_pk"
          label="dummy_pay_pk"
      >
        <el-input
            v-model="form.dummy_pay_pk"
            auto-complete="off"
            :placeholder="$t('message.inputAmount')"
        />
      </el-form-item>
    </el-form>
    <div
        slot="footer"
        class="dialog-footer"
    >
      <el-button
          @click="handleCancelClick"
      >
        {{ $t('text.cancel') }}
      </el-button>
      <el-button
          type="primary"
          @click="handleConfirmClick"
      >
        {{ $t('text.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "PackageAmountEdit",
  props: {
    show: Boolean,
  },
  computed: {
    title() {
      return this.$t('text.editPackageAmount');
    }
  },
  data() {
    return {
      loading: false,
      form: {
        qq_pay_pk: "0",
        qq_pay_game_pk: "0",
        dummy_pay_pk: "0"
      },
      rules: {
        qq_pay_pk: [
          {required: true, message: this.$t("message.inputAmount"), trigger: ["change", "blur"]},
          {pattern: /^\d{0,16}(\.\d{1,4})?$/, message: this.$t("message.amountError"), trigger: ["change", "blur"]}

        ],
        qq_pay_game_pk: [
          {required: true, message: this.$t("message.inputAmount"), trigger: ["change", "blur"]},
          {pattern: /^\d{0,16}(\.\d{1,4})?$/, message: this.$t("message.amountError"), trigger: ["change", "blur"]}
        ],
        dummy_pay_pk: [
          {required: true, message: this.$t("message.inputAmount"), trigger: ["change", "blur"]},
          {pattern: /^\d{0,16}(\.\d{1,4})?$/, message: this.$t("message.amountError"), trigger: ["change", "blur"]}
        ]
      },
    };
  },
  methods: {
    handleDialogOpen() {
      this.loading = true;
      this.loadConfiguration();
    },
    handleDialogClose() {
      this.closeDialog();
    },
    handleCancelClick() {
      this.closeDialog();
    },
    handleConfirmClick() {
      this.submit();
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if(valid) {
          this.loading = true;
          this.$axios
              .post("/config/package-config/save", this.form)
              .then((res) => {
                this.loading = false;
                if (res.code === 200) {
                  this.$notify.success({
                    title: this.$t("text.prompt"),
                    message: res.msg
                  });

                  this.$bus.$emit("refresh");
                  this.closeDialog();
                  return true;
                } else {
                  this.$notify.error({
                    title: this.$t("text.prompt"),
                    message: res.msg
                  });
                  return false;
                }
              });
        } else {
          return false;
        }
      });
    },
    loadConfiguration() {
      let error = "";
      this.$axios
          .get("/config/package-config/select", {params: {}})
          .then((res) => {
            if (res.code === 200) {
              this.form = res.data;
              return true;
            } else {
              error = res.msg;
              return false;
            }
          })
          .catch((res) => {
            error = res.msg;
          })
          .finally(() => {
            this.loading = false;
            if (error !== "") {
              this.$notify.error({
                title: this.$("text.prompt"),
                message: error
              });
              this.closeDialog();
            }
          });
    },
    closeDialog() {
      this.$refs["form"].resetFields();
      this.$emit("update:show", false);
    },
  },
};
</script>